const categories = {
    list: () => 'getAllCategories',
    subCategorylist: (id) => `subcategories/${id}`,
    create: () => 'create/category',
    update: (id) => `update/${id}`,
    getById: (id) => `category/${id}`,
    delete: (id) => `delete/category/${id}`,
}
export default categories
